export default __webpack_public_path__ + "static/media/ehLogo_400x400.e34f5c26.png";